module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_05_sp-c3b9ea8a6484b1de8f08b978a90a08ec.png";